import axios from "axios";
import { getAuthToken } from "./authHelpers";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "https://api-staging.wihan.in/", // 13.204.122.222
  // baseURL: "http://192.168.1.15:1234/",
  // baseURL: "http://192.168.1.2:1234/",
  // baseURL: "https://api.wihan.in/",  // 15.206.223.186

}); 

axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }

  // Prevent string "null" or "undefined" from being passed in request URLs
  if (config.url && config.url.includes("?")) {
    const [path, queryString] = config.url.split("?");
    const params = new URLSearchParams(queryString);
    const cleanParams = new URLSearchParams();
    for (const [key, value] of Array.from(params.entries())) {
      if (value !== "null" && value !== "undefined") {
        cleanParams.append(key, value);
      }
    }
    const cleanQuery = cleanParams.toString();
    config.url = cleanQuery ? `${path}?${cleanQuery}` : path;
  }

  if (config.params) {
    Object.keys(config.params).forEach((key) => {
      if (
        config.params[key] === null ||
        config.params[key] === undefined ||
        config.params[key] === "null" ||
        config.params[key] === "undefined"
      ) {
        delete config.params[key];
      }
    });
  }

  return config;
});

export default axiosInstance;


// STAGING IP: 13.204.122.222

// LIVE IP: 15.206.223.186
